import posthog from 'posthog-js';

import type { EnabledPostHogConfig } from './posthog-config';

export const POSTHOG_CONSENT_EVENT = 'vetsi:analytics-consent';

interface PostHogClient {
  init: typeof posthog.init;
  opt_in_capturing: typeof posthog.opt_in_capturing;
  opt_out_capturing: () => void;
}

interface ConsentWindow extends Window {
  __VETSI_STATISTICS_CONSENT__?: boolean;
}

export function startPostHogConsentBridge(
  config: EnabledPostHogConfig | null,
  client: PostHogClient = posthog,
  browserWindow: ConsentWindow = window,
): () => void {
  if (!config) return () => undefined;

  let initialized = false;

  const applyConsent = (granted: boolean): void => {
    if (!granted) {
      if (initialized) client.opt_out_capturing();
      return;
    }

    if (initialized) {
      client.opt_in_capturing({ captureEventName: false });
      return;
    }

    initialized = true;
    client.init(config.apiKey, {
      ...config.options,
      loaded: (loadedClient) => {
        loadedClient.opt_in_capturing({ captureEventName: false });
      },
    });
  };

  applyConsent(browserWindow.__VETSI_STATISTICS_CONSENT__ === true);

  const onConsent = (event: Event): void => {
    applyConsent((event as CustomEvent<boolean>).detail === true);
  };
  browserWindow.addEventListener(POSTHOG_CONSENT_EVENT, onConsent);

  return () =>
    browserWindow.removeEventListener(POSTHOG_CONSENT_EVENT, onConsent);
}
